<template>
    <div :class="formGroupClass">
        <label :class="labelClass">{{ title }}</label>
        <div v-tooltip.left="tooltip" :class="inputClass">
            <vue-multiselect
                    v-model="selectValues"
                    :options="options"
                    :searchable="true"
                    :multiple="true"
                    :label="label"
                    :track-by="trackBy"
                    placeholder=""
                    :select-label="labelSelect"
                    :deselect-label="labelDeselect"
                    :selected-label="labelSelected"
                    @select="$emit('dispatch', $event) && $emit('change', $event)"
                    @remove="$emit('change', $event)"
                    :disabled="disabled"
            >
                <span slot="noResult">Brak wyników. Spróbuj zmienić wpisywaną frazę.</span>
            </vue-multiselect>
            <span v-if="errorText" class="help-block">
                <p> {{errorText}} </p>
            </span>
        </div>
    </div>
</template>

<script>
import VTooltip from 'v-tooltip'
import VueMultiselect from 'vue-multiselect'
import Vue from "vue";

Vue.use(VTooltip)

export default {
  components: {
    VueMultiselect
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'name'
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    checked: {
      type: Array,
      default: null
    },
    value: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    errors: {
      type: Object,
      default: () => {}
    },
    labelSize : {
      type: Number,
      default: 3
    },
    tooltip: {
      type: String,
      default: '',
    },
    disabled:{
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      id : `form_${this.name}`,
      errorText: false,
      selectValues : [],
      checkValues: [],
      labelSelect: Translator.trans('multiselect.select'),
      labelDeselect: Translator.trans('multiselect.remove'),
      labelSelected: Translator.trans('multiselect.selected'),
      formGroupClass: 'form-group',
      labelClass: `control-label col-md-${this.labelSize}`,
      inputClass: `col-md-${12 - this.labelSize}`,
      forceChange: 0,
    }
  },
  watch : {
    value: function(value) {
      this.checkValues = value
    },
    selectValues: function () {
      this.checkValues = this.selectValues.map(x => x[this.trackBy])
      this.emit()
    },
    errors: function(value) {
      if (value[this.name]) {
        this.errorText = Object.values(value[this.name]).join()
        this.formGroupClass += ' has-error'
      } else {
        this.errorText = false
        this.formGroupClass = 'form-group'
      }
    },
    options : function() {
      this.checkValues = this.checked
      this.selectValues = this.prepareValue()
      this.emit()
    },
    checked : function() {
      this.checkValues = this.checked
      this.selectValues = this.prepareValue()
      this.emit()
    },

  },

  mounted() {
    this.checkValues = this.checked ? this.checked : this.value
    this.selectValues = this.prepareValue()
    // eslint-disable-next-line no-console
    console.warn('[multiselect.vue]=> This component is marked as deprecated, please use NewMultiSelect.vue')
  },
  methods: {
    emit: function() {
      this.$emit('input', this.checkValues )
    },
    forceSetValues(values) {
      this.checkValues = values
      this.selectValues = this.prepareValue()
      this.emit()
    },
    prepareValue() {
      if (!this.checkValues) {
        return []
      }

      let prepareValues = []
      for (let i = 0; i < this.options.length ; i++) {
        if (this.checkValues.indexOf(this.options[i][this.trackBy]) > -1) {
          let tmp = {}
          tmp[this.trackBy] = this.options[i][this.trackBy]
          tmp[this.label] = this.options[i][this.label]
          prepareValues.push(tmp)
        }
      }

      return prepareValues
    }
  },

}
</script>
